import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { SERVICES } from "@/data/services";
import { SITE, waLink } from "@/lib/config";
import { IgIcon } from "@/components/ui/IgIcon";

const Col = ({ title, links }) => (
  <div>
    <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.22em] text-sky-brand">{title}</p>
    <ul className="space-y-3">
      {links.map((l) => (
        <li key={l.to}>
          <Link to={l.to} className="link-u text-[15px] text-ice hover:!text-white" data-testid={`footer-link-${l.to.replace(/\W+/g, "-")}`}>{l.label}</Link>
        </li>
      ))}
    </ul>
  </div>
);

export const Footer = () => (
  <footer className="relative overflow-hidden bg-slateb text-ice" data-testid="site-footer">
    <div className="wrap pt-20 sm:pt-28">
      <div className="flex flex-col justify-between gap-10 border-b border-white/15 pb-16 lg:flex-row lg:items-end">
        <h2 className="max-w-3xl font-display text-4xl font-bold leading-[1.05] !text-white sm:text-6xl">
          Temukan jalan keluar, <span className="serif-it text-sky-brand">bangun kembali</span> ketenangan finansial.
        </h2>
        <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="footer-wa-cta" className="btn btn-sky shrink-0 !px-8 !py-4">
          Konsultasi via WhatsApp <ArrowUpRight size={16} />
        </a>
      </div>
      <div className="grid gap-12 py-16 sm:grid-cols-2 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <Logo light testId="footer-logo" />
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ice">
            MIKA SOLUTION merupakan bagian dari{" "}
            <a href={SITE.parent.url} target="_blank" rel="noopener noreferrer" className="link-u font-semibold text-white" data-testid="footer-parent-link">{SITE.parent.name}</a>.
          </p>
          <address className="mt-6 space-y-2 text-[14px] not-italic leading-relaxed text-ice" data-testid="footer-contact">
            <span className="block">{SITE.address}</span>
            <a href={SITE.phoneHref} className="link-u block text-white" data-testid="footer-phone">{SITE.phone}</a>
            <a href={`mailto:${SITE.email}`} className="link-u block text-white" data-testid="footer-email">{SITE.email}</a>
            <span className="block">{SITE.hours}</span>
          </address>
        </div>
        <div className="space-y-10 lg:col-span-3">
          <Col title="Layanan" links={SERVICES.map((s) => ({ to: `/layanan/${s.slug}`, label: s.name }))} />
          <Col title="Legal" links={[{ to: "/kebijakan-privasi", label: "Kebijakan Privasi" }, { to: "/syarat-ketentuan", label: "Syarat & Ketentuan" }]} />
        </div>
        <div className="lg:col-span-2"><Col title="Perusahaan" links={[{ to: "/tentang-kami", label: "Tentang Kami" }, { to: "/konsultan", label: "Tim Konsultan" }, { to: "/artikel", label: "Artikel" }, { to: "/faq", label: "FAQ" }, { to: "/kontak", label: "Kontak" }]} /></div>
        <div className="lg:col-span-3" data-testid="footer-location">
          <p className="mb-5 text-[11px] font-bold uppercase tracking-[0.22em] text-sky-brand">Lokasi Kantor</p>
          <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer" className="group relative block overflow-hidden rounded-2xl border border-white/15" data-testid="footer-map-link">
            <iframe title="Peta lokasi kantor" src={SITE.mapsEmbed} className="pointer-events-none h-40 w-full grayscale-[35%] transition-[filter] duration-500 group-hover:grayscale-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" tabIndex={-1} />
            <span className="absolute bottom-3 left-3 rounded-full bg-white px-3 py-1.5 text-[12px] font-semibold text-slateb shadow">Buka di Google Maps ↗</span>
          </a>
          <a href={SITE.instagramUrl} target="_blank" rel="noopener noreferrer" className="group mt-5 flex items-center gap-3 rounded-full border border-white/20 py-2 pl-2 pr-5 transition-colors hover:border-sky-brand" data-testid="footer-instagram">
            <span className="grid h-9 w-9 place-items-center rounded-full bg-gradient-to-tr from-[#f9ce34] via-[#ee2a7b] to-[#6228d7] text-white transition-transform duration-500 group-hover:rotate-[-10deg]"><IgIcon size={17} /></span>
            <span className="text-[14px] font-semibold text-white">@{SITE.instagram}</span>
          </a>
        </div>
      </div>
      <p className="border-t border-white/15 py-6 text-[13px] leading-relaxed text-ice/90">
        Informasi di situs ini bersifat edukasi umum dan bukan jaminan hasil. Ketersediaan program penyelesaian bergantung pada kondisi akun dan persetujuan kreditur.
      </p>
      <div className="flex flex-col justify-between gap-2 pb-8 text-[13px] text-ice/90 sm:flex-row">
        <span>© {new Date().getFullYear()} Mika Solution. Seluruh hak dilindungi.</span>
        <span>Kami tidak pernah meminta PIN, OTP, CVV, atau password Anda.</span>
      </div>
    </div>
    <div aria-hidden="true" className="pointer-events-none select-none whitespace-nowrap text-center font-display text-[13.2vw] font-extrabold leading-[0.75] tracking-[-0.05em] text-white/[0.05]">MIKA SOLUTION</div>
  </footer>
);
